/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import BananaMoon from './BananaMoon'
import './plugins'

Vue.config.productionTip = false

Vue.mixin(require('./base'))

/**
 * Next, we'll setup some of BananaMoon's Vue components that need to be global
 * so that they are always available.
 */
import './components'

/**
 * Finally, we'll create this Vue Router instance and register all of the
 * Banana Moon routes. Once that is complete, we will create the Vue instance
 * and hand this router to the Vue instance. Then Banana Moon is all ready!
 */
;(function() {
    this.CreateBananaMoon = function(config) {
        return new BananaMoon(config)
    }
}.call(window))



// WEBPACK FOOTER //
// ./resources/js/app.js